import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleArrowOutRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3 12L7.6 12",
			strokeWidth: 1.5,
			strokeLinejoin: "round",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6 8.3L22.3 12L18.6 15.7",
			strokeWidth: 1.5,
			strokeLinejoin: "round",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3 19.3C15.3 23.3 8.7 23.3 4.7 19.3C0.7 15.3 0.7 8.7 4.7 4.7C8.7 0.7 15.3 0.7 19.3 4.7",
			strokeWidth: 1.5,
			strokeLinejoin: "round",
			stroke: "currentColor"
		})
	]
});
export { SvgCircleArrowOutRight as ReactComponent };
